import React, {FC, Fragment} from "react";
import Link from "next/link";
import {url} from "../../../services/utils";
import cls from "../shop.module.scss";
import {cartProductType} from "../../../types/state";

interface IInfoProps {
    options: {optionTitle: string, valueTitle: string}[] | null;
    product: cartProductType
}

const ProductColumnInfo:FC<IInfoProps> = ({ product, options }) => {
    return (
        <Fragment>
            <Link href={url.product(product)} className={cls["cart-table__product-name"]}>
                <a>{product?.name}</a>
            </Link>
            {Array.isArray(options) && options.length > 0 && (
                <ul className={cls["cart-table__options"]}>
                    {options.map(({optionTitle, valueTitle}, index) => (
                        <li key={index}>{`${optionTitle}: ${valueTitle}`}</li>
                    ))}
                </ul>
            )}
        </Fragment>
    )
}

export default ProductColumnInfo;